import { createContext } from 'react';
import { DEFAULT_BRAND_ACCENT, DEFAULT_THEME, chartPalette, deriveBrandColors } from '@tallyframe/core';
export function resolveBrand(brand) {
    const { mark, text } = deriveBrandColors(brand?.accent ?? DEFAULT_BRAND_ACCENT);
    return {
        name: brand?.name ?? '',
        logoUrl: brand?.logoUrl ?? null,
        mark,
        text,
        palette: chartPalette(mark),
        theme: brand?.theme ?? DEFAULT_THEME
    };
}
/** `--rp-brand`/`--rp-brand-text` inline on a surface's root beat
 *  tokens.css's `:where(...)` default (spec §4.1) regardless of specificity. */
export function brandStyle(resolved) {
    return { '--rp-brand': resolved.mark, '--rp-brand-text': resolved.text };
}
export const BrandContext = createContext(resolveBrand());
//# sourceMappingURL=brand.js.map